export const CERISE_ENDPOINT = 'services.cerise.media';
